module.exports = Object.freeze({
  NOT_PAYED: "NOT_PAYED",
  VALIDATED: "VALIDATED",
  PAYMENT_FAILURE: "PAYMENT_FAILURE",
  REFUNDED: "REFUNDED",
});
